<nz-divider class="mt-sm"></nz-divider>
<h3>Payment Details:</h3>
<nz-divider class="mt-sm"></nz-divider>
<form nz-form *ngIf="load" [nzLayout]="'vertical'" [formGroup]="paymentDetailsGroup">
  <div nz-row>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="mr-md">
        <nz-form-label nzRequired>Status</nz-form-label>
        <nz-form-control [nzErrorTip]="'Payment Mode is Required'">
          <nz-select required nzPlaceHolder="Status" id="status" formControlName="status" (ngModelChange)="approveStatus($event)">
            <nz-option *ngFor="let fa of listApproveStatus" [nzLabel]="fa.description" [nzValue]="fa.code"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="showPaymentMode">
      <nz-form-item class="mr-lg">
        <nz-form-label nzRequired>Payment Mode</nz-form-label>
        <nz-form-control [nzErrorTip]="'Payment Mode is Required'">
          <nz-select required nzPlaceHolder="Payment Mode" id="payMode" formControlName="payMode" (ngModelChange)="payModeChange($event)">
            <nz-option *ngFor="let fa of listofpayMode" [nzLabel]="fa.description" [nzValue]="fa.code"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="payModeCash">
      <nz-form-item class="mr-md">
        <nz-form-label nzRequired> Reciept Number
          <span nz-tooltip nzTitle="Reciept Number">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Reciept Number is Required'">
          <input required nz-input id="receiptNumber" formControlName="receiptNumber" name="receiptNumber" placeholder="Reciept Number"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="payModeCheque">
      <nz-form-item class="mr-md">
        <nz-form-label nzRequired> Bank Name
          <span nz-tooltip nzTitle="Bank Name">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Bank Name is Required'">
          <nz-select required [nzPlaceHolder]="'Bank Name'" id="bankName" formControlName="bankName" (ngModelChange)="onBankSelect($event)">
            <nz-option *ngFor="let fa of listofBanks" [nzLabel]="fa.label"  [nzValue]="fa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="payModeCheque">
      <nz-form-item class="mr-lg">
        <nz-form-label nzRequired> Branch Name
          <span nz-tooltip nzTitle="Branch Name">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Branch Name is Required'">
          <nz-select required [nzPlaceHolder]="'Branch Name'" id="branchName" formControlName="branchName" (ngModelChange)="onBranchSelect($event)" >
            <nz-option *ngFor="let fa of listofBranchNameBasedOnBankCode" [nzLabel]="fa.label"  [nzValue]="fa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="payModeCheque">
      <nz-form-item class="mr-md">
        <nz-form-label nzRequired>Cheque Amount</nz-form-label>
        <nz-form-control [nzErrorTip]="'Cheque Amount is Required'">
          <input required nz-input id="chequeAmount" formControlName="chequeAmount" name="chequeAmount" placeholder="Cheque Amount"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="payModeCheque">
      <nz-form-item class="mr-lg">
        <nz-form-label nzRequired>Cheque Number</nz-form-label>
        <nz-form-control [nzErrorTip]="'Cheque Number is Required'">
          <input required nz-input id="chequeNumber" formControlName="chequeNumber" name="chequeNumber" placeholder="Cheque Number"/>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="payModeCheque">
      <nz-form-item class="mr-md">
        <nz-form-label nzRequired>Cheque Date</nz-form-label>
        <nz-form-control [nzErrorTip]="'Cheque Date is Required'">
          <nz-date-picker required [nzDisabledDate]="disabledChequeDate" id="chequeDate" formControlName="chequeDate" nzSize="default" [(ngModel)]="chequeDate"
            nzPlaceHolder="Cheque Date" [nzShowToday]="false" nzFormat="dd-MM-yyyy" (ngModelChange)="onEndChange($event)">
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <div class="float-right">
      <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
    </div>
  </div>
</div>
</form>
